import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import styles from '../Administration.module.css';

function DeviceActiveComponent({
  activeRecord,
  testDevice,
  updateDevice,
  deleteDevice,
}) {
  const { clientName, clientIpAddress, clientMacAddress, clientUuid } =
    activeRecord;
  const activeItemRows = [
    {
      label: 'Device Name',
      value: clientName,
      actionFunction: updateDevice,
      actionText: 'Update Device',
    },
    {
      label: 'IP Address',
      value: clientIpAddress,
      actionFunction: deleteDevice,
      actionText: 'Delete Device',
    },
    {
      label: 'MAC Address',
      value: clientMacAddress,
      actionFunction: testDevice,
      actionText: 'Test Device',
    },
    {
      label: '',
      value: '',
    },
  ];

  return (
    <div
      className={styles.activeContentWrapper}
      style={
        activeRecord && clientUuid
          ? { alignItems: 'flex-start' }
          : { alignItems: 'center', height: '100%' }
      }
    >
      {activeRecord && clientUuid ? (
        activeItemRows.map((item) => {
          return (
            <div className={styles['active-item-container']} key={item}>
              <div className={styles['active-item-leftside']}>
                {item.label && (
                  <span
                    className={styles['active-item-label']}
                    style={{ marginBottom: '3px' }}
                  >
                    {item.label}
                  </span>
                )}
                {item.type === 'array'
                  ? item.value &&
                    item.value.map((label) => (
                      <span
                        className={styles['active-item-label']}
                      >{`- ${label}`}</span>
                    ))
                  : item.value && (
                      <span className={styles['active-item-value']}>
                        {typeof item.value === 'string'
                          ? item.value
                          : `${item.value.getDate()} - ${
                              item.value.getMonth() + 1
                            } - ${item.value.getFullYear()}`}
                      </span>
                    )}
              </div>
              {item.actionFunction && (
                <div className={styles['active-item-rightside']}>
                  <Button
                    onClick={item.actionFunction}
                    className={styles.actionButton}
                  >
                    {item.actionText}
                  </Button>
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className={styles.noImagePreview}>
          <span className={styles.noPreviewText}>There is no data</span>
        </div>
      )}
    </div>
  );
}

DeviceActiveComponent.defaultProps = {
  activeRecord: {},
  testDevice: (f) => f,
  updateDevice: (f) => f,
  deleteDevice: (f) => f,
};

DeviceActiveComponent.propTypes = {
  activeRecord: PropTypes.instanceOf(Object),
  testDevice: PropTypes.func,
  updateDevice: PropTypes.func,
  deleteDevice: PropTypes.func,
};

export default DeviceActiveComponent;
